import React, { useContext, useEffect } from 'react'
import './Dashboard.css'
import { motion } from 'framer-motion';
import Tangelo from "../../imgs/tangelo.png";
import Next from "../../imgs/next.png";
import Test from '../Test/Test';
import Dashcontendts from '../Dashcontents/Dashcontendts';
import Sidebar from '../Sidebar/Sidebar';
import Globalcontext from '../../Context/Globalcontext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Dashboard = (props) => {
  const a = useContext(Globalcontext);
  const navigate = useNavigate();
  const notifyerror = (msg) => toast.error(msg);
  const notifysuccess = (msg) => toast.success(msg);
  const bodycontainerVariants = {
    true: {
      marginLeft: '0px',
      width: '-webkit-calc(100vw - 14rem)'
    },
    false: {
      marginLeft: '-130px',
      width: '-webkit-calc(100vw - 6rem)',
      transition: {
        delay: 0.6
      }
    }
  }

  useEffect(() => {
    if (localStorage.getItem("gllogin") === '') {
      navigate('/');
    }
  })

  const handleprofile = () => {
    navigate('/myaccount');
  }

  const handlesignout = () => {
    localStorage.setItem('glname', '');
    localStorage.setItem('glgrade', '');
    localStorage.setItem('glschool', '');
    localStorage.setItem('glcoordinator', '');
    localStorage.setItem('gldob', '');
    localStorage.setItem('glgender', '');
    localStorage.setItem('glstudentstatus', '');
    localStorage.setItem('gllanguage', '');
    localStorage.setItem('glmobno', '');
    localStorage.setItem('glgrade2', '');
    localStorage.setItem('glresult', '');
    localStorage.setItem('gletime', '');
    localStorage.setItem('glrand', '');
    localStorage.setItem('glmaintest', '');
    localStorage.setItem('gllogin', '');

    setempty();

    navigate('/');
    notifysuccess('Logged out..');

  }

  const setempty = () => {
    a.setq1array({ "option": '', "correct": '' });
    a.setq2array({ "option": '', "correct": '' });
    a.setq3array({ "option": '', "correct": '' });
    a.setq4array({ "option": '', "correct": '' });
    a.setq5array({ "option": '', "correct": '' });
    a.setq6array({ "option": '', "correct": '' });
    a.setq7array({ "option": '', "correct": '' });
    a.setq8array({ "option": '', "correct": '' });
    a.setq9array({ "option": '', "correct": '' });
    a.setq10array({ "option": '', "correct": '' });
    a.setq11array({ "option": '', "correct": '' });
    a.setq12array({ "option": '', "correct": '' });
    a.setq13array({ "option": '', "correct": '' });
    a.setq14array({ "option": '', "correct": '' });
    a.setq15array({ "option": '', "correct": '' });
    a.setq16array({ "option": '', "correct": '' });
    a.setq17array({ "option": '', "correct": '' });
    a.setq18array({ "option": '', "correct": '' });
    a.setq19array({ "option": '', "correct": '' });
    a.setq20array({ "option": '', "correct": '' });

    a.setq1('');
    a.setq2('');
    a.setq3('');
    a.setq4('');
    a.setq5('');
    a.setq6('');
    a.setq7('');
    a.setq8('');
    a.setq9('');
    a.setq10('');
    a.setq11('');
    a.setq12('');
    a.setq13('');
    a.setq14('');
    a.setq15('');
    a.setq16('');
    a.setq17('');
    a.setq18('');
    a.setq19('');
    a.setq20('');

    a.setSeconds(59);
    a.setMinutes(29);
    a.setIndex(0);
    a.setCorrect(0);
    a.setAnasweredtemp(0);
    a.setElminutes(0);
    a.setElseconds(0);
    a.setSolutionflag("false");

  }


  const bodyVariants = {
    true: {
      width: '100%',
    },
    false: {
      width: '100%',
      transition: {
        delay: 0.6
      }
    }
  }

  window.onpopstate = () => {
    //navigate(1);
  }

  return (


    <motion.div
      initial={`${props.open}`}
      animate={`${props.open}`}
      variants={bodycontainerVariants}
      className="body_container">

      <motion.div
        initial={`${props.open}`}
        animate={`${props.open}`}
        variants={bodyVariants}
        className="body">
        <div className="profileinfo">
          <div onClick={handleprofile} className="firstpart2">
            <img className='imglogo' src={Tangelo} alt="" />
            <span className='sname'>{localStorage.getItem('glname')} ({localStorage.getItem('glgrade')})</span>
            <img className='next' src={Next} alt="" />
          </div>
          <button onClick={handlesignout} className='signout'>Sign Out</button>
        </div>
        <Dashcontendts />
      </motion.div>

    </motion.div>

  )
}

export default Dashboard
